import React from "react";
import Favicon from "@App/favicon.ico";
import Styles from "./NotFound.module.scss";
import { useTranslation } from "react-i18next";

export const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className={Styles.wrapper}>
      <a href="/">
        <img src={Favicon} alt="favicon" />
      </a>
      <h2>{t("notFound.message")}</h2>
      <a href="/">{t("notFound.backLink")}</a>
    </div>
  );
};
